import { render, staticRenderFns } from "./Activos.vue?vue&type=template&id=6ee510e4"
import script from "./Activos.vue?vue&type=script&lang=js"
export * from "./Activos.vue?vue&type=script&lang=js"
import style0 from "./Activos.vue?vue&type=style&index=0&id=6ee510e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports